export default __webpack_public_path__ + "c8f5b1b.png";